
export class VehicleVersion {
    versionId: number;
    constructor(item) {
        this.versionId = item?.id;

    }
}